import { Link, useSearchParams } from "react-router-dom";
import { Alert } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { PageContainer } from "@volca/ui/components/ui/page-components";
import { useBusiness } from "@/core/business";
import { AccessHeader } from "./access-header";
import { useWorkbookAccessEditorAccess } from "./permissions";
import { useWorkbookAccessSettings } from "./query";
import { WorkbookAccessEditor } from "./workbook-access-editor";
import { WorkbookAccessLoadingState } from "./workbook-access-loading-state";

const WorkbookAccessPage = () => {
  const [params] = useSearchParams();
  const { businessId, isLoading } = useBusiness();
  const { canManage, isAccessLoading, accessQuery } =
    useWorkbookAccessEditorAccess(businessId);
  const query = useWorkbookAccessSettings(
    canManage ? (businessId ?? null) : null,
  );
  if (isLoading || isAccessLoading || (canManage && query.isLoading))
    return <WorkbookAccessLoadingState />;
  if (
    !canManage ||
    !businessId ||
    accessQuery.isError ||
    !query.data ||
    query.isError ||
    query.data.access_keys.length === 0
  )
    return (
      <PageContainer>
        <AccessHeader />
        <Alert
          color={
            query.isError || accessQuery.isError || !canManage
              ? "danger"
              : "information"
          }
        >
          {!businessId
            ? "Select a business to manage workbook access."
            : accessQuery.isError
              ? "Could not check workbook access permissions."
              : !canManage
                ? "Only authorized managers can manage workbook access."
                : query.isError
                  ? "Could not load workbook access."
                  : "This business has no access keys yet."}
        </Alert>
        {(query.isError || accessQuery.isError) && (
          <Button
            variant="secondary"
            onClick={() =>
              void (accessQuery.isError
                ? accessQuery.refetch()
                : query.refetch())
            }
          >
            Try again
          </Button>
        )}
        {businessId && (
          <Link to={`/business-settings/${businessId}/users`}>
            Back to Users
          </Link>
        )}
      </PageContainer>
    );
  return (
    <PageContainer variant="workspace">
      <WorkbookAccessEditor
        key={businessId}
        businessId={businessId}
        settings={query.data}
        initialPersonId={params.get("person")}
      />
    </PageContainer>
  );
};
export default WorkbookAccessPage;
